import { useCallback } from 'react';
import {
  useTripStore,
  useSetTripFilters,
  useResetDaySelection,
  useSetLastAddedExperienceId,
  useSetCompareWithVersion,
  useSetFocusDay,
  useSetMapState,
} from '@koob/trip-designer';

// Replaces the deleted trip designer context provider's `resetContext`
// (US-053), byte-equivalent to it: not store data itself, so it has no
// selector hook equivalent, and stays a plain app hook (mirrors TO's own
// US-051 hook).
export const useResetTripDesigner = () => {
  const resetTrip = useTripStore((state) => state.resetTrip);
  const setTripFilters = useSetTripFilters();
  const resetDaySelection = useResetDaySelection();
  const setLastAddedExperienceId = useSetLastAddedExperienceId();
  const setCompareWithVersion = useSetCompareWithVersion();
  const setFocusDay = useSetFocusDay();
  const setMapState = useSetMapState();

  return useCallback(() => {
    setTripFilters(null);
    resetDaySelection();
    setLastAddedExperienceId(null);
    setCompareWithVersion(null);
    setFocusDay(null);
    setMapState({ center: null, zoom: null });

    resetTrip();
  }, [
    resetTrip,
    setTripFilters,
    resetDaySelection,
    setLastAddedExperienceId,
    setCompareWithVersion,
    setFocusDay,
    setMapState,
  ]);
};
